import React, { useState } from "react";
import { Form, Input, Space, Typography } from "antd";
import { decimalRegex, formatToDecimal, integerRegex, limitDecimalInputPrecision } from "../../utils/formaters";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SEC_FONT_GREY } from "../../constant/colors";

const { Text } = Typography;

const StyledFormItem = styled(Form.Item)`
  ${(props) => {
    if (props.style?.display) {
      return `.ant-row {
      display: ${props.style.display};
      width:100%;
    }`;
    }
  }}
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const NumericalInput = ({
  dataTMId,
  name,
  editable = true,
  defaultValue,
  min = 0,
  max = Number.MAX_VALUE,
  onChange,
  allowClear = true,
  placeholder,
  prefix = "",
  isInteger = false,
  precision = 2,
  rules = [],
  label,
  showLabel = false,
  labelStyle,
  style = [],
  strong = false,
  required = false,
  recordInfo
}) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);

  return (
    <StyledFormItem
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={
        showLabel ? (
          <Text style={labelStyle} strong={strong}>
            {label}
          </Text>
        ) : null
      }
      style={{ ...style, display: "inline-block" }}
      colon={false}
      required={required}
      validateFirst={true}
      rules={[
        {
          pattern: isInteger ? integerRegex : decimalRegex,
          message: isInteger ? t("form.validation.integers_only") : t("form.validation.numbers_only")
        },
        {
          validateTrigger: "onChange",
          message: t("form.validation.range", { name, min, max }),
          validator: (_, value) => {
            if (value >= min && value <= max) {
              return Promise.resolve();
            } else {
              return Promise.reject();
            }
          }
        },
        ...rules
      ]}
    >
      {editable ? (
        <Input
          data-tm-id={dataTMId}
          defaultValue={defaultValue}
          allowClear={hover && allowClear}
          prefix={prefix}
          placeholder={placeholder}
          formatter={(e) => formatToDecimal(e.target.value)}
          onKeyDown={(e) => limitDecimalInputPrecision(e, precision)}
          onPaste={(e) => {
            if (isNaN(e?.target?.value)) {
              e.preventDefault();
              return false;
            }
          }}
          onChange={onChange}
          style={{ width: "100%" }}
        />
      ) : (
        <Space>
          <Text data-tm-id={dataTMId}>{defaultValue ? `${prefix}${defaultValue}` : ""}</Text>
        </Space>
      )}
    </StyledFormItem>
  );
};

export { NumericalInput };
